import { useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setPageInfo } from '../../store/pageSlice';
import { mainRoutes, authRoutes } from '../../router/routes';
import { RootState } from '../../store/store';
import { PageState } from '../../store/pageSlice';
import { fireActiveOnSite, setupScanCheckoutStepListener } from '../../utils/dataLayer';

const PageListener: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const currentPage = useSelector((state: RootState) => state.page);
  
  // Setup scan checkout step listener on mount
  useEffect(() => {
    setupScanCheckoutStepListener();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    const scrollTimeout = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
    
    const allRoutes = [...mainRoutes, ...authRoutes];
    const currentRoute = allRoutes.find((route) => {
      return (
        route.path === location.pathname ||
        (route.path.includes(':') && matchPath(route.path, location.pathname))
      );
    });

    let newPageInfo: Omit<PageState, 'sidebarCollapsed'> = {
      path: location.pathname,
      title: 'Unknown',
      showSidebar: false,
    };

    if (currentRoute) {
      newPageInfo = {
        path: currentRoute.path,
        title: currentRoute.meta?.title || '',
        showSidebar: currentRoute.meta?.showSidebar ?? true,
        isDynamicTitle: currentRoute.meta?.isDynamicTitle,
      };
    }

    const isDifferent =
      currentPage.path !== newPageInfo.path ||
      currentPage.title !== newPageInfo.title ||
      currentPage.showSidebar !== newPageInfo.showSidebar ||
      currentPage.isDynamicTitle !== newPageInfo.isDynamicTitle;

    if (isDifferent) {
      dispatch(setPageInfo(newPageInfo));
    }

    // Fire active_on_site event on route change
    fireActiveOnSite();

    return () => {
      clearTimeout(scrollTimeout);
    };
  }, [location, dispatch, currentPage]);

  return null;
};

export default PageListener;
